type Props = {
  children?: React.ReactNode;
};

const TableHead = ({ children }: Props) => {
  return (
    <thead className="border-b border-gray-400 border-solid">{children}</thead>
  );
};

export default TableHead;
